import { useEffect, useRef, useState } from 'react';
import { useGeolocated } from 'react-geolocated';

import { AuthReqDeviceCoordsDto } from '~modules/auth/model';
import { journalStore } from '~pages/session/journal.store.ts';

export function useJournal() {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const [__, setIdle] = useState<null | any>();
	const {
		isPending,
		journal,
		clear,
		create,
		setPhoto,
		setPosition,
		coordinates,
		deviceInfo,
		isDeviceChecked,
		isIncognitoBlocked,
		initDevice,
	} = journalStore();
	const { coords, getPosition } = useGeolocated({
		positionOptions: {
			enableHighAccuracy: true,
		},
		geolocationProvider: navigator.geolocation,
		watchPosition: false,
		isOptimisticGeolocationEnabled: true,

		watchLocationPermissionChange: true,
		onSuccess: position => {
			setPosition({
				lat: position.coords.latitude,
				lon: position.coords.longitude,
			} as AuthReqDeviceCoordsDto);
		},
	});
	const ref = useRef(false);

	if (!ref.current && isPending) {
		ref.current = true;
		console.log('init', coords, coordinates);
		if (coords && coords.latitude && coords.longitude) {
			setPosition({ lat: coords.latitude, lon: coords.longitude });
		} else {
			getPosition();
		}
		// Признаки устройства собираем заранее: часть из них асинхронна,
		// а предупреждение о приватном режиме нужно показать до сканирования
		initDevice();
		clear();
	}

	useEffect(() => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		setIdle((old: any) => {
			if (old) {
				clearTimeout(old);
				return null;
			}
			return old;
		});

		if (journal && !journal.id) {
			// ошибка
			setIdle(
				setTimeout(
					() => {
						clear();
					},
					1000 * 60 * 5,
				),
			);
		}
	}, [clear, journal]);

	return {
		isPending,
		journal,
		create,
		setPhoto,
		clear,
		coordinates,
		getPosition,
		deviceInfo,
		isDeviceChecked,
		isIncognitoBlocked,
	};
}
